export default "__VITE_ASSET__qc01cslv__"